<template>
    <div>
        <mtop  /> 
        <div class="mux-l"></div>
        <router-view></router-view>
        <mbot  />
    </div>
</template>
<script>
import mtop from '../components/mtop.vue'
import mbot from '../components/mbot.vue'
export default {
    components:{
        mtop,mbot
    },
    name:'phoneEntry',
    data() {
        return {
        
        }
    },
    created() {

        this.$router.push({name:'phoneIndex'})
        this.$store.dispatch("setMenuInd",0)


    },
    mounted(){
        document.title = "深圳市极智数字科技有限公司"
    },
}
</script>
<style lang="less" scoped>
.mux-l{
    height: 3.2rem;
}
</style>